module.exports = __webpack_public_path__ + "static/InnovaUnderground-c23017971fc4b3f8c794a2671a479d25.png";